import React from 'react';
import ViewSupplier from '../../components/supplier_comp/ViewSupplier';

/**
 * ViewSupplierPage — Page wrapper for View Supplier master module
 */
const ViewSupplierPage = () => {
    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            <ViewSupplier />
        </div>
    );
};

export default ViewSupplierPage;